const meridians = Array.from({ length: 9 });
const latitudes = Array.from({ length: 7 });
const nodes = Array.from({ length: 24 });

export const NetworkSphere = () => (
  <div className="relative mx-auto flex aspect-square w-full max-w-[460px] items-center justify-center overflow-hidden">
    <div className="absolute inset-[4%] rounded-full bg-[radial-gradient(circle_at_center,hsl(var(--primary)/0.18),transparent_60%)] blur-sm" />
    <div className="network-sphere relative h-[82%] w-[82%] rounded-full border border-primary/40 shadow-[0_0_70px_hsl(var(--primary)/0.16)]">
      {meridians.map((_, index) => (
        <span
          key={`m-${index}`}
          className="network-sphere-ring absolute inset-0 rounded-full border border-primary/25"
          style={{ transform: `rotateY(${index * 20}deg)` }}
        />
      ))}
      {latitudes.map((_, index) => (
        <span
          key={`l-${index}`}
          className="absolute left-0 top-1/2 h-[1px] w-full rounded-full bg-primary/25"
          style={{ transform: `translateY(${(index - 3) * 38}px) scaleX(${1 - Math.abs(index - 3) * 0.09})` }}
        />
      ))}
      {nodes.map((_, index) => {
        const angle = (index * 137.5) % 360;
        const radius = 23 + (index % 5) * 8;
        const x = 50 + Math.cos(angle * Math.PI / 180) * radius;
        const y = 50 + Math.sin(angle * Math.PI / 180) * radius * 0.72;
        return <span key={index} className="absolute h-1.5 w-1.5 rounded-full bg-amber shadow-[0_0_14px_hsl(var(--amber)/0.75)]" style={{ left: `${x}%`, top: `${y}%` }} />;
      })}
    </div>
  </div>
);
